export default __webpack_public_path__ + "static/media/document-logo-2.1d9fc575.svg";